import { render, staticRenderFns } from "./farming-page.vue?vue&type=template&id=cb544ea8&scoped=true&"
import script from "./farming-page.vue?vue&type=script&lang=ts&"
export * from "./farming-page.vue?vue&type=script&lang=ts&"
import style0 from "./farming-page.vue?vue&type=style&index=0&id=cb544ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb544ea8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VImg,VSpacer})
